import moment from "moment-timezone";
const localTimeZone = moment.tz.guess();
const timeZoneOffset = new Date().getTimezoneOffset();
const timeZoneAbbrevation = moment.tz.zone(localTimeZone)?.abbr(timeZoneOffset);

export const getHumanReadableDatetime = (datetime?: Date) =>
  datetime ? moment(datetime).format("lll") + " " + timeZoneAbbrevation : "";

export default getHumanReadableDatetime;
